(ns frontend.ux-overhaul.listing.real-estate.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.real-estate.event :as real-estate-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "real-estate-listing")

(defn- open-real-estate!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/real-estate})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/real-estate
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :real-estate
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-real-estate
                                 :label    (loc/tr :real-estate-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::real-estate-event/create-real-estate]}
                                {:id                  :bulk-edit-real-estates
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::real-estate-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-real-estates
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::real-estate-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-real-estates
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::real-estate-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-real-estates-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::real-estate-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/real-estate})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :real-estates)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.real-estate/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::real-estate-event/create-real-estate])
         :on-row-clicked           open-real-estate!
         :on-card-clicked          open-real-estate!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/real-estate}]
       [menu-actions/field-requirements-modal]])}))
